import { BriefingStatusApiEnum } from '../../../api/briefings/enum/briefing-status-api.enum';

export enum BriefingStatusEnum {
    DRAFT = 'DRAFT',
    SENT = 'SENT',
    FAILED = 'FAILED',
    CANCELLED = 'CANCELLED',
    ACTIVE = 'ACTIVE',
    PAUSED = 'PAUSED',
    SCHEDULED = 'SCHEDULED',
    EXPIRED = 'EXPIRED'
}

// F/E consider both B/E PENDING and SCHEDULED as SCHEDULED
export const briefingStatusMapFromApi: Map<BriefingStatusApiEnum, BriefingStatusEnum> = new Map<BriefingStatusApiEnum, BriefingStatusEnum>([
    [BriefingStatusApiEnum.DRAFT, BriefingStatusEnum.DRAFT],
    [BriefingStatusApiEnum.PENDING, BriefingStatusEnum.SCHEDULED],
    [BriefingStatusApiEnum.SCHEDULED, BriefingStatusEnum.SCHEDULED],
    [BriefingStatusApiEnum.SENT, BriefingStatusEnum.SENT],
    [BriefingStatusApiEnum.FAILED, BriefingStatusEnum.FAILED],
    [BriefingStatusApiEnum.CANCELLED, BriefingStatusEnum.CANCELLED],
    [BriefingStatusApiEnum.ACTIVE, BriefingStatusEnum.ACTIVE],
    [BriefingStatusApiEnum.PAUSED, BriefingStatusEnum.PAUSED],
    [BriefingStatusApiEnum.EXPIRED, BriefingStatusEnum.EXPIRED]
]);

export const briefingStatusMapToApi: Map<BriefingStatusEnum, BriefingStatusApiEnum> = new Map<BriefingStatusEnum, BriefingStatusApiEnum>([
    [BriefingStatusEnum.DRAFT, BriefingStatusApiEnum.DRAFT],
    [BriefingStatusEnum.SENT, BriefingStatusApiEnum.SENT],
    [BriefingStatusEnum.FAILED, BriefingStatusApiEnum.FAILED],
    [BriefingStatusEnum.CANCELLED, BriefingStatusApiEnum.CANCELLED],
    [BriefingStatusEnum.ACTIVE, BriefingStatusApiEnum.ACTIVE],
    [BriefingStatusEnum.PAUSED, BriefingStatusApiEnum.PAUSED],
    [BriefingStatusEnum.SCHEDULED, BriefingStatusApiEnum.PENDING],
    [BriefingStatusEnum.EXPIRED, BriefingStatusApiEnum.EXPIRED]
]);
